export const environment = {
  "urls": {
    "apiUrl": "https://hcv-dp.tscerp.com",
    "botApiUrl": "https://demo.tscti.com/",
    "hcvApiUrl": "/v1"
  },
};
